// import React, { useEffect, useState } from 'react';
// import {
//   TableContainer,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TablePagination,
//   CircularProgress,
//   Typography,
//   Box,
//   Skeleton,
//   Alert,
//   useTheme,
//   useMediaQuery
// } from '@mui/material';

// export default function OpenOrderTable() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

//   // Mock API call - replace with your actual API endpoint
//   const fetchData = async () => {
//     setLoading(true);
//     setError('');
    
//     try {
//       // Simulate API delay
//       await new Promise(resolve => setTimeout(resolve, 1000));
      
//       // Replace this URL with your actual API endpoint
//       const response = await fetch('https://jsonplaceholder.typicode.com/users');
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const result = await response.json();
      
//       // Transform data to match your order structure
//       const transformedData = result.map((user, index) => ({
//         id: user.id,
//         orderNumber: `ORD-${1000 + index}`,
//         customerName: user.name,
//         email: user.email,
//         phone: user.phone,
//         amount: (Math.random() * 1000 + 100).toFixed(2),
//         status: ['Pending', 'Processing', 'Shipped', 'Delivered'][Math.floor(Math.random() * 4)],
//         date: new Date(Date.now() - Math.random() * 10000000000).toLocaleDateString()
//       }));
      
//       setData(transformedData);
//     } catch (err) {
//       console.error('Error fetching data:', err);
//       setError('Failed to load orders. Please try again later.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     const colors = {
//       'Pending': 'warning',
//       'Processing': 'info',
//       'Shipped': 'primary',
//       'Delivered': 'success'
//     };
//     return colors[status] || 'default';
//   };

//   // Skeleton loading rows
//   const SkeletonRows = ({ count = 5 }) => (
//     <>
//       {[...Array(count)].map((_, index) => (
//         <TableRow key={index}>
//           {[...Array(isMobile ? 3 : isTablet ? 5 : 8)].map((_, cellIndex) => (
//             <TableCell key={cellIndex}>
//               <Skeleton variant="text" width="100%" />
//             </TableCell>
//           ))}
//         </TableRow>
//       ))}
//     </>
//   );

//   // Paginate data
//   const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

//   return (
//     <Box sx={{ width: '100%', mt: 2 }}>
//       <Paper 
//         elevation={3} 
//         sx={{ 
//           borderRadius: 3,
//           overflow: 'hidden',
//           background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
//           border: '1px solid rgba(226, 232, 240, 0.3)'
//         }}
//       >
//         {/* Header */}
//         <Box sx={{ 
//           p: 3, 
//           borderBottom: '1px solid rgba(226, 232, 240, 0.3)',
//           background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
//         }}>
//           <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b' }}>
//             Open Orders
//           </Typography>
//           <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
//             Manage and track your open orders
//           </Typography>
//         </Box>

//         {error && (
//           <Box sx={{ p: 2 }}>
//             <Alert 
//               severity="error" 
//               sx={{ borderRadius: 2 }}
//               action={
//                 <Typography 
//                   variant="body2" 
//                   sx={{ cursor: 'pointer', textDecoration: 'underline' }}
//                   onClick={fetchData}
//                 >
//                   Retry
//                 </Typography>
//               }
//             >
//               {error}
//             </Alert>
//           </Box>
//         )}

//         <TableContainer sx={{ maxHeight: { xs: 400, sm: 500, md: 600 } }}>
//           <Table 
//             stickyHeader 
//             aria-label="open orders table"
//             sx={{ 
//               minWidth: { xs: 300, sm: 650, md: 800 },
//               '& .MuiTableCell-head': {
//                 backgroundColor: '#f1f5f9',
//                 fontWeight: 600,
//                 fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                 color: '#334155'
//               }
//             }}
//           >
//             <TableHead>
//               <TableRow>
//                 <TableCell sx={{ minWidth: { xs: 80, sm: 120 } }}>Order #</TableCell>
//                 <TableCell sx={{ minWidth: { xs: 100, sm: 150 } }}>Customer</TableCell>
//                 {!isMobile && (
//                   <TableCell sx={{ minWidth: { sm: 180, md: 200 } }}>Email</TableCell>
//                 )}
//                 {!isMobile && !isTablet && (
//                   <TableCell sx={{ minWidth: 130 }}>Phone</TableCell>
//                 )}
//                 <TableCell align="right" sx={{ minWidth: 80 }}>Amount</TableCell>
//                 {!isMobile && (
//                   <TableCell sx={{ minWidth: 100 }}>Status</TableCell>
//                 )}
//                 {!isMobile && !isTablet && (
//                   <TableCell sx={{ minWidth: 100 }}>Date</TableCell>
//                 )}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <SkeletonRows count={rowsPerPage} />
//               ) : paginatedData.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={isMobile ? 3 : isTablet ? 5 : 8} align="center">
//                     <Box sx={{ py: 4 }}>
//                       <Typography variant="h6" color="text.secondary">
//                         No orders found
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                         There are no open orders to display
//                       </Typography>
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 paginatedData.map((row) => (
//                   <TableRow 
//                     key={row.id}
//                     sx={{ 
//                       '&:nth-of-type(odd)': { 
//                         backgroundColor: 'rgba(248, 250, 252, 0.5)' 
//                       },
//                       '&:hover': { 
//                         backgroundColor: 'rgba(59, 130, 246, 0.04)' 
//                       },
//                       cursor: 'pointer'
//                     }}
//                   >
//                     <TableCell sx={{ 
//                       fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                       fontWeight: 600,
//                       color: '#3b82f6'
//                     }}>
//                       {row.orderNumber}
//                     </TableCell>
//                     <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
//                       {row.customerName}
//                     </TableCell>
//                     {!isMobile && (
//                       <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
//                         {row.email}
//                       </TableCell>
//                     )}
//                     {!isMobile && !isTablet && (
//                       <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
//                         {row.phone}
//                       </TableCell>
//                     )}
//                     <TableCell 
//                       align="right" 
//                       sx={{ 
//                         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//                         fontWeight: 600 
//                       }}
//                     >
//                       ${row.amount}
//                     </TableCell>
//                     {!isMobile && (
//                       <TableCell>
//                         <Box
//                           sx={{
//                             display: 'inline-block',
//                             px: 2,
//                             py: 0.5,
//                             borderRadius: '16px',
//                             fontSize: '0.75rem',
//                             fontWeight: 600,
//                             textTransform: 'uppercase',
//                             backgroundColor: `${getStatusColor(row.status)}.100`,
//                             color: `${getStatusColor(row.status)}.800`,
//                             border: `1px solid`,
//                             borderColor: `${getStatusColor(row.status)}.200`
//                           }}
//                         >
//                           {row.status}
//                         </Box>
//                       </TableCell>
//                     )}
//                     {!isMobile && !isTablet && (
//                       <TableCell sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
//                         {row.date}
//                       </TableCell>
//                     )}
//                   </TableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {!loading && !error && (
//           <TablePagination
//             component="div"
//             count={data.length}
//             page={page}
//             onPageChange={handleChangePage}
//             rowsPerPage={rowsPerPage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             rowsPerPageOptions={[5, 10, 25, 50]}
//             sx={{
//               borderTop: '1px solid rgba(226, 232, 240, 0.3)',
//               backgroundColor: '#f8fafc',
//               '& .MuiTablePagination-toolbar': {
//                 fontSize: { xs: '0.75rem', sm: '0.875rem' }
//               }
//             }}
//           />
//         )}
//       </Paper>
//     </Box>
//   );
// }


import React, { useEffect, useState } from 'react';
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Alert,
  Button,
  Box,
  Chip,
  useTheme,
  useMediaQuery,
  IconButton,
  Tooltip,
  Avatar,
  Collapse,
  Divider
} from '@mui/material';
import {
  ShoppingCart,
  Refresh,
  Phone,
  LocationOn,
  Person,
  CheckCircle,
  HourglassEmpty,
  Cancel,
  LocalShipping,
  Receipt,
  Visibility,
  ExpandMore,
  ExpandLess,
  Medication,
  AccountBalanceWallet,
  Store
} from '@mui/icons-material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useParams } from 'react-router-dom';

// Medstown theme
const medstownTheme = createTheme({
  palette: {
    primary: {
      main: '#1d5244',
      light: '#4a7c59',
      dark: '#0f2920',
    },
    secondary: {
      main: '#2e7d32',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#f8f9fa',
          fontWeight: 600,
          color: '#374151',
        },
      },
    },
  },
});

// Loading Skeleton Component
const LoadingSkeleton = () => (
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          {['Order ID', 'Customer', 'Phone', 'Address', 'Payment', 'Status', 'Date', 'Actions'].map((header) => (
            <TableCell key={header}>
              <Skeleton variant="text" width={80} height={24} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(6)].map((_, index) => (
          <TableRow key={index}>
            <TableCell>
              <Skeleton variant="text" width={100} height={20} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={120} height={20} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={100} height={20} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={150} height={20} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={120} height={20} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

// Mobile Card Component
const MobileCard = ({ order }) => {
  const [expanded, setExpanded] = useState(false);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered': return 'success';
      case 'pending': return 'warning';
      case 'cancelled': return 'error';
      case 'confirmed': return 'info';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered': return <CheckCircle sx={{ fontSize: 16 }} />;
      case 'pending': return <HourglassEmpty sx={{ fontSize: 16 }} />;
      case 'cancelled': return <Cancel sx={{ fontSize: 16 }} />;
      case 'confirmed': return <LocalShipping sx={{ fontSize: 16 }} />;
      default: return <Receipt sx={{ fontSize: 16 }} />;
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 2, borderRadius: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main' }}>
            #{order.orderId}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {order.orderType}
          </Typography>
        </Box>
        <Chip
          icon={getStatusIcon(order.status)}
          label={order.status}
          color={getStatusColor(order.status)}
          size="small"
          sx={{ fontWeight: 500 }}
        />
      </Box>

      <Box mb={2}>
        <Box display="flex" alignItems="center" mb={1}>
          <Person sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {order.customerName}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mb={1}>
          <Phone sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            {order.customerPhone}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-start" mb={1}>
          <LocationOn sx={{ fontSize: 16, mr: 1, color: 'text.secondary', mt: 0.2 }} />
          <Typography variant="body2" color="text.secondary">
            {order.customer_address.details.house}, {order.customer_address.details.apartment}
            <br />
            {order.customer_address.city}, {order.customer_address.district} - {order.customer_address.postalCode}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box>
          <Typography variant="body2" color="text.secondary">
            Total: ₹{order.totalPrice}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Payment: {order.payment.method}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {new Date(order.createdAt).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Button
          size="small"
          onClick={() => setExpanded(!expanded)}
          endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
        >
          {expanded ? 'Hide Details' : 'Show Details'}
        </Button>
        <Box>
          {order.precriptionUrl && (
            <IconButton
              size="small"
              onClick={() => window.open(order.precriptionUrl, '_blank')}
              color="primary"
            >
              <Visibility />
            </IconButton>
          )}
        </Box>
      </Box>

      <Collapse in={expanded}>
        <Divider sx={{ my: 2 }} />
        <Box>
          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
            Order Items ({order.orderDetails.length})
          </Typography>
          {order.orderDetails.map((item, index) => (
            <Paper key={index} sx={{ p: 1.5, mb: 1, bgcolor: 'grey.50' }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {item.medicineName}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {item.short_composition} • {item.pack_size_label}
              </Typography>
              <Box display="flex" justifyContent="space-between" mt={1}>
                <Typography variant="body2">
                  Qty: {item.medicineQuantity}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  ₹{item.customerGetAmount}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default function OpenOrderTable({userId}) {
  // const { userId } = useParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // const fetchOrders = async () => {
  //   setLoading(true);
  //   setError(null);
    
  //   try {
  //     const baseUrl = 'https://api.medstown.com';
  //     const targetUserId = userId || 'USER3fa82222-85ea-4f57-aab5-3b2a46094143';
  //     const response = await fetch(
  //       `${baseUrl}/api/admin-controls/user/orders/${targetUserId}`,
  //       {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         }
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const result = await response.json();
      
  //     if (result.success && result.data) {
  //       // Sort by creation date in descending order (newest first)
  //       const sortedList = (result.data.list || []).sort((a, b) => 
  //         new Date(b.createdAt) - new Date(a.createdAt)
  //       );
  //       setOrders(sortedList);
  //       setTotalCount(result.data.totalCount || 0);
  //     } else {
  //       throw new Error(result.message || 'Failed to fetch orders');
  //     }
  //   } catch (err) {
  //     console.error('Error fetching orders:', err);
  //     setError(err.message || 'An error occurred while fetching orders');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchOrders = async () => {
  setLoading(true);
  setError(null);

  try {
    const baseUrl = "https://api.medstown.com";
    const targetUserId = userId || "USER3fa82222-85ea-4f57-aab5-3b2a46094143";
    const response = await fetch(
      `${baseUrl}/api/admin-controls/user/orders/${targetUserId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json(); // ✅ Always parse JSON

    if (!response.ok) {
      // show API message if available
      throw new Error(result.message || `HTTP error! status: ${response.status}`);
    }

    if (result.success && result.data) {
      // Sort by creation date in descending order (newest first)
      const sortedList = (result.data.list || []).sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setOrders(sortedList);
      setTotalCount(result.data.totalCount || 0);
    } else {
      throw new Error(result.message || "Failed to fetch orders");
    }
  } catch (err) {
    console.error("Error fetching orders:", err);
    setError(err.message || "An error occurred while fetching orders");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if (userId) {
      fetchOrders();
    }
  }, [userId]);

  const handleRetry = () => {
    fetchOrders();
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered': return 'success';
      case 'pending': return 'warning';
      case 'cancelled': return 'error';
      case 'confirmed': return 'info';
      default: return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'delivered': return <CheckCircle sx={{ fontSize: 16 }} />;
      case 'pending': return <HourglassEmpty sx={{ fontSize: 16 }} />;
      case 'cancelled': return <Cancel sx={{ fontSize: 16 }} />;
      case 'confirmed': return <LocalShipping sx={{ fontSize: 16 }} />;
      default: return <Receipt sx={{ fontSize: 16 }} />;
    }
  };

  if (loading) {
    return (
      <ThemeProvider theme={medstownTheme}>
        <Container maxWidth="xl" sx={{ py: 3 }}>
          <Paper sx={{ p: 3, mb: 3, bgcolor: 'primary.main', color: 'white' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center">
                <ShoppingCart sx={{ mr: 2, fontSize: 32 }} />
                <Box>
                  <Skeleton variant="text" width={200} height={32} />
                  <Skeleton variant="text" width={150} height={20} />
                </Box>
              </Box>
            </Box>
          </Paper>
          <LoadingSkeleton />
        </Container>
      </ThemeProvider>
    );
  }

  if (error) {
    return (
      <ThemeProvider theme={medstownTheme}>
        <Container maxWidth="xl" sx={{ py: 3 }}>
          <Alert 
            severity="error"
            sx={{ mb: 3, borderRadius: 2 }}
            action={
              <Button 
                color="inherit" 
                size="small" 
                onClick={handleRetry}
                startIcon={<Refresh />}
              >
                Retry
              </Button>
            }
          >
            <Typography variant="h6" gutterBottom>{error}</Typography>
            
          </Alert>
        </Container>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={medstownTheme}>
      <Container maxWidth="xl">
        {/* Header */}
        {/* <Paper sx={{ p: 3, mb: 3, bgcolor: 'primary.main', color: 'white' }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <ShoppingCart sx={{ mr: 2, fontSize: 32 }} />
              <Box>
                <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: 700 }}>
                  User Orders
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {totalCount} total orders found
                </Typography>
              </Box>
            </Box>
            <Tooltip title="Refresh Data">
              <IconButton onClick={handleRetry} sx={{ color: 'white' }}>
                <Refresh />
              </IconButton>
            </Tooltip>
          </Box>
        </Paper> */}

        {orders.length === 0 ? (
          <Alert severity="info" sx={{ borderRadius: 2 }}>
            <Typography variant="h6" gutterBottom>No orders found</Typography>
            This user hasn't placed any orders yet.
          </Alert>
        ) : (
          <>
            {/* Mobile View */}
            {isMobile ? (
              <Box>
                {orders.map((order) => (
                  <MobileCard key={order._id} order={order} />
                ))}
              </Box>
            ) : (
              /* Desktop Table View */
              <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Receipt sx={{ mr: 1, fontSize: 18 }} />
                          Order ID
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Person sx={{ mr: 1, fontSize: 18 }} />
                          Customer
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Phone sx={{ mr: 1, fontSize: 18 }} />
                          Phone
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <LocationOn sx={{ mr: 1, fontSize: 18 }} />
                          Address
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <AccountBalanceWallet sx={{ mr: 1, fontSize: 18 }} />
                          Payment
                        </Box>
                      </TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Order Date</TableCell>
                      {/* <TableCell>Actions</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orders.map((order) => (
                      <TableRow key={order._id} hover>
                        <TableCell>
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                              {order.orderId}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {order.orderType}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {order.customerName}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            {order.customerPhone}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 200 }}>
                            {order.customer_address.details.house}
                            <br />
                            {order.customer_address.city}, {order.customer_address.district}
                            <br />
                            {order.customer_address.region} - {order.customer_address.postalCode}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Chip
                              label={order.payment.method}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                            <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 500 }}>
                              ₹{order.totalPrice}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip
                            icon={getStatusIcon(order.status)}
                            label={order.status}
                            color={getStatusColor(order.status)}
                            size="small"
                            sx={{ fontWeight: 500 }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            {new Date(order.createdAt).toLocaleDateString('en-IN', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box display="flex" gap={1}>
                            {order.precriptionUrl && (
                              <Tooltip title="View Prescription">
                                <IconButton
                                  size="small"
                                  onClick={() => window.open(order.precriptionUrl, '_blank')}
                                  color="primary"
                                >
                                  <Visibility />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </Container>
    </ThemeProvider>
  );
}

